import { z } from 'zod';
import { mediaSchema } from './media.js';

var SlideElementType = /* @__PURE__ */ ((SlideElementType2) => {
  SlideElementType2["TEXT"] = "TEXT";
  SlideElementType2["MEDIA"] = "MEDIA";
  SlideElementType2["WEBPAGE"] = "WEBPAGE";
  SlideElementType2["SHAPE1D"] = "SHAPE1D";
  SlideElementType2["SHAPE2D"] = "SHAPE2D";
  SlideElementType2["TABLE"] = "TABLE";
  return SlideElementType2;
})(SlideElementType || {});
const slideElementSchema = z.object({
  _id: z.string(),
  type: z.nativeEnum(SlideElementType),
  table: z.object({
    rows: z.number(),
    cols: z.number()
  }).optional(),
  placeholder: z.string(),
  placeholderSize: z.number(),
  transform: z.object({
    position: z.object({
      x: z.number(),
      y: z.number()
    }),
    size: z.object({
      width: z.number(),
      height: z.number()
    }),
    rotation: z.number()
  }),
  zIndex: z.number(),
  data: z.object({
    html: z.string(),
    media: mediaSchema
  }),
  isLocked: z.boolean().default(false).optional(),
  isBackground: z.boolean().default(false).optional()
});

export { SlideElementType, slideElementSchema };
